export const ALL_COUNTRIES_REQUEST = 'ALL_COUNTRIES_REQUEST';
export const ALL_COUNTRIES_SUCCESS = 'ALL_COUNTRIES_SUCCESS';
export const ALL_COUNTRIES_ERROR = 'ALL_COUNTRIES_ERROR';
